import React, { useState, useEffect } from 'react';
import { useApi } from '../../../../context/ApiContext/ApiContext';
import { ThemeProvider } from '../../themes/ThemeProvider';
import { processEndpointValues, restructureObject } from '../moduleUtils/apiObjectFormatting';
import moduleConfig from './testModuleConfig';
import FormField from '../../featureOverlay/baseElements/FormField';
import ModuleContainer from '../../featureOverlay/baseElements/ModuleContainer';
import ModuleHeader from '../../featureOverlay/baseElements/ModuleHeader';
import ModuleDescription from '../../featureOverlay/baseElements/ModuleDescription';
import ModuleBody from '../../featureOverlay/baseElements/ModuleBody';
import InfoComponent from '../../elements/InfoComponent';
import ButtonComponent from '../../elements/ButtonComponent';

const TestModule = ({ id, data }) => {
  // API CALL CONTEXT
  const { moduleNodes, registerModule, updateModuleConfig, updateApiParams, setExecutionOrder } = useApi();
  
  // UPDATE MODULEEXPORTER
    const [endpointValues, setEndpointValues] = useState(() => {
      return moduleNodes[id] || 
        {
          "endpoint_0": {
            "path": "/api2/cloudslicer/jobs/list",
            "method": "GET",
            "root_url": "https://services.uplynk.com",
            "params": {
              "limit": "",
              "skip": ""
            }
          }
        };
    });
  
  const [results, setResults] = useState(null);

  
  // Handle form field changes by updating the specific endpoint parameter directly
  const handleChange = (endpointKey, paramName, value) => {
    setEndpointValues(prev => ({
      ...prev,
      [endpointKey]: {
        ...prev[endpointKey],
        params: {
          ...prev[endpointKey].params,
          [paramName]: value
        }
      }
    }));
  };

  // Handle form submission with API context integration
  const handleSubmit = async () => {
    console.log("");
    console.log("handleSubmit-endpointValues", endpointValues);
    console.log("");
    console.log("handleSubmit-moduleConfig", moduleConfig);
    console.log("");
    try {
      // Process the endpoint values
      const processedData = processEndpointValues(endpointValues, moduleConfig);
      console.log("processedData", processedData);
      
      const apple = restructureObject(processedData, moduleConfig);
      console.log("apple: ", apple);
      
      // Update the module's configuration
      updateModuleConfig(id, processedData.endpoints, processedData.validation);  
      
    } catch (error) {
      console.error('Error processing form:', error);
    }
    console.log("moduleNodes: ", moduleNodes);
  };

 
  // UPDATE MODULEEXPORTER
  useEffect(() => {
    if (!id) return;

    if (!moduleNodes[id]) {
      const moduleLabel = data?.label || '';

      registerModule(id, endpointValues, moduleLabel);

    } else {

      setEndpointValues(moduleNodes[id]);
    }
    
    return () => {
    };
  }, [id]);
  

  return (
      <ThemeProvider themeKey="uplynk" size="large">
        <ModuleContainer>
          <ModuleHeader title="New Module" />
          <ModuleDescription description="" />
          <ModuleBody endpoints={moduleConfig.moduleConfig.endpoints} readyState={moduleNodes[id]?.readyState}>
              {/* Field: limit for /api2/cloudslicer/jobs/list */}
              <FormField 
                type="text"
                label="limit"
                value={endpointValues['endpoint_0']?.params?.['limit']}
                onChange={(value) => handleChange('endpoint_0', 'limit', value)}
                
                placeholder="50"
                
              />

              {/* Field: skip for /api2/cloudslicer/jobs/list */}
              <FormField 
                type="text"
                label="skip"
                value={endpointValues['endpoint_0']?.params?.['skip']}
                onChange={(value) => handleChange('endpoint_0', 'skip', value)}
                
                placeholder="50"
                
              />

              {/* Button: button_1741264053649 */}
              <ButtonComponent 
                id="button_1741264053649"
                label="Apply" 
                variant="primary"
                onClick={handleSubmit}
              />
          </ModuleBody>
        </ModuleContainer>
      </ThemeProvider>
    );
}

export default TestModule;